import styled from "@emotion/styled";

export const Wrapper = styled.div`
  margin-bottom: 20px;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    margin-bottom: 40px;
  }
`;

export const Title = styled.h1`
  margin-bottom: ${p => p.theme.space[5]}px;

  font-size: 26px;
  font-weight: ${p => p.theme.fontWeight.semiBold};

  @media (min-width: ${p => p.theme.screenSizes.mdMax}) {
    margin-bottom: 20px;

    font-size: 42px;
    font-weight: ${p => p.theme.fontWeight.bold};
  }
`;

export const Description = styled.div`
  font-size: 16px;
  line-height: 1.6;
  color: ${props => props.theme.colors.secondary.gray};

  text-align: justify;

  a {
    color: ${p => p.theme.colors.hover.background};
    cursor: pointer;

    @media (hover) {
      &:hover,
      &:focus {
        text-decoration: underline;
      }
    }
  }

  @media (min-width: ${p => p.theme.screenSizes.mdMax}) {
    font-size: ${p => p.theme.fontSizes.m};
    line-height: 1.8;
  }
`;
